import React, { useCallback } from "react";

import useMainSidebarStore from "../../../../stores/mainSidebarStore";
import Avatar from "./Avatar";
import DropdownIcon from "./DropdownIcon";
import UserInfo from "./UserInfo";

function UserDropdown() {
  const dropdownActive = useMainSidebarStore((s) => s.userDropdownActive);

  const handleClick = useCallback(() => {
    useMainSidebarStore.getState().toggleUserDropdown();
  }, []);
  return (
    <button
      onClick={handleClick}
      type="button"
      className={`main-sidebar__user-dropdown ${
        dropdownActive ? "main-sidebar__user-dropdown--active" : ""
      } rounded d-flex align-items-center justify-content-between btn p-0 p-2 w-100 gap-2`}
    >
      <div className="d-flex align-items-center gap-2">
        <Avatar />
        <UserInfo />
      </div>
      <DropdownIcon />
    </button>
  );
}

export default UserDropdown;
